import { baseurl } from 'router/constants';
import logError from 'util/misc/log-error';
import clearObject from 'util/misc/clear-object';

/**
 * Object that will contain all the app routes by name
 *
 * @example
 * registry.product_list = "produkte/liste"
 */
export const registry = Object.create(null);

/**
 * Object that will contain all the app route names by url
 *
 * It is used to quickly get the name of an url route
 * @type {{}}
 */
export const urls = Object.create(null);

/**
 * Add a new route to the registry
 * @param {string} name - name to identify the route
 * @param {string} url - path to named page
 * @param {string} title - title we want to use for this page
 * @returns {object} the new path object just added
 */
export function add(name, url, title) {
    if (registry[name]) {
        logError(new Error(`The template "${ name }" was already used for another route, please use unique names for each route.`));
    }

    registry[name] = {
        url,
        title,
    };

    urls[url] = name;

    return registry[name];
}

/**
 * Get a raw route from the registry
 * @param {string} name - name of the route object hopefully stored in the registry
 * @returns {string} the path object including all the languages
 */
export function get(name) {
    if (!name) {
        return baseurl();
    }

    if (!registry[name]) {
        logError(new Error(`The route name "${ name }" was not found. Was it defined via CMS?`));
    }

    return registry[name];
}

export function resolve(url) {
    if (!url) {
        return urls[baseurl()];
    }

    return urls[url] || '';
}

/**
 * Remove the old cached data
 */
export function flush() {
    clearObject(urls);
    clearObject(registry);
}

export default registry;



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/router/registry.js